<template>
  <div class="pickupBoxForm">
    <FormKit
      type="form"
      name="pickupBox"
      id="pickupbox"
      v-model="formData"
      :actions="false"
    >
      <div class="container">
        <Input
          v-for="el in infoFromPikupBox"
          :key="el.id"
          :type="el.type"
          :name="el.name"
          :label="$t(el.label)"
          :validation="el.validation"
          :validationMessages="{
            required: $t('validation.required')
          }"
          validation-visibility="dirty"
          :preserve="el.name === 'name'"
          :disabled="el.name === 'id'"
          :data-testid="el.dataTestId"
        />
        <Dropdown
          class="dropdown-pickupboxForm"
          :selectedOption="langsDropdown.selectedOption"
          :options="langsDropdown.options"
          :label="$t('UILanguages')"
          :multiple="true"
          @selectOption="selectLanguage"
          data-testid="dropdownPickupboxForm"
        />
        <Input
          type="text"
          name="language"
          v-model="formData.language"
          :label="$t('defaultLanguages')"
          placeholder="N/A"
          readonly
          :data-testid="'inputDefaultLanguages'"
        />
      </div>
    </FormKit>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

import {
  optionsLanguageEn,
  optionsLanguageFi,
  optionsLanguageSv,
  optionsLanguageNo,
  langsEn,
  langsFi,
  langsSv,
  langsNo
} from '@/services/languageService';

import { infoFromPikupBox, infoTemperature } from './configs';
import { Option } from '@/types';

@Options({
  name: 'PickupBoxForm',
  data() {
    return {
      formData: {
        name: '',
        id: '',
        street: '',
        zipCode: '',
        city: '',
        country: '',
        phoneNumber: '',
        uiLanguages: '',
        language: ''
      },
      infoFromPikupBox,
      infoTemperature,
      optionsLanguageEn,
      optionsLanguageFi,
      optionsLanguageSv,
      optionsLanguageNo,
      langsEn,
      langsFi,
      langsSv,
      langsNo,
      langsDropdown: {
        selectedOption: [],
        options: []
      }
    };
  },
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    initLanguage() {
      const optionsMappings: { [key: string]: Option[] } = {
        en: optionsLanguageEn,
        fi: optionsLanguageFi,
        sv: optionsLanguageSv,
        no: optionsLanguageNo
      };

      const userLanguage = this.user?.appLanguage;
      if (userLanguage && optionsMappings[userLanguage]) {
        this.langsDropdown.options = optionsMappings[userLanguage];
      }
    },
    selectLanguage(option: Option) {
      this.langsDropdown.selectedOption = option;
    }
  },
  watch: {
    'langsDropdown.selectedOption': {
      immediate: true,
      handler() {
        const languages = this.langsDropdown.selectedOption.map(
          (i: Option) => i.label
        );
        const languagesValues = this.langsDropdown.selectedOption.map(
          (i: Option) => i.value
        );

        this.formData.language = languages[0];
        this.formData.uiLanguages = languagesValues || '';
      }
    },
    formData() {
      if (this.formData) {
        this.initLanguage();

        const uiLanguages = this.formData.uiLanguages;

        const languageMappings: { [key: string]: Record<string, unknown> } = {
          en: langsEn,
          fi: langsFi,
          sv: langsSv,
          no: langsNo
        };

        const userLanguage = this.user?.appLanguage;
        if (userLanguage && languageMappings[userLanguage]) {
          const selectedOption = uiLanguages.map((i: string) => ({
            label: languageMappings[userLanguage][i],
            value: i
          }));

          this.langsDropdown.selectedOption = selectedOption;
        }
      }
    }
  }
})
export default class PickupBoxForm extends Vue {}
</script>

<style lang="scss">
.pickupBoxForm {
  width: 100%;
  max-width: 848px;
  margin-top: 32px;
  .container {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    padding: 0;
    .formkit-outer {
      width: 100%;
      height: 48px;
      width: 377px;
    }
    .dropdown-pickupboxForm {
      width: 377px;
      height: 48px;
      margin-bottom: 30px;
      .dropdown {
        height: 48px;
      }
      .input-dropdown {
        width: 100%;
        max-width: 377px;
        height: 50px;
        font-family: 'Ubuntu-Regular';
        margin-bottom: 30px;
      }
    }
  }
}
</style>
